var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'CoreGroupbuyingsList'
      }
    }
  }, [_vm._v("團購管理")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(_vm._s(_vm.isEdit ? "編輯團購" : "我要開團"))])], 1)], 1)])]), _c('div', {
    staticClass: "email-wrapper wrapper"
  }, [_c('div', {
    staticClass: "row align-items-stretch"
  }, [_c('div', {
    staticClass: "mail-sidebar d-none d-lg-block col-md-2 pt-3 bg-white"
  }, [_c('div', {
    staticClass: "menu-bar"
  }, [_c('ul', {
    staticClass: "menu-items"
  }, [!_vm.isCreate ? _c('li', {
    staticClass: "compose mb-3"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "disabled": !_vm.isEdit || !_vm.isDraftGroupbuying
    },
    on: {
      "click": function click($event) {
        return _vm.startGroupbuying();
      }
    }
  }, [_vm._v(_vm._s(_vm.isEdit ? "發起團購" : "編輯團購"))])]) : _vm._e(), _c('li', {
    class: _vm.step == '' ? 'active' : '',
    style: _vm.isCreate ? '' : 'cursor: pointer;',
    on: {
      "click": function click($event) {
        return _vm.goToStep('');
      }
    }
  }, [_c('a', [_vm._v("團購設定")]), _c('i', {
    class: "fa ".concat(_vm.groupbuying ? 'fa-check-circle' : 'fa fa-check-circle-o'),
    style: _vm.groupbuying ? 'color:green;' : '',
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('li', {
    class: _vm.step == '#product' ? 'active' : '',
    style: _vm.isCreate ? 'cursor: not-allowed;' : 'cursor: pointer;',
    on: {
      "click": function click($event) {
        return _vm.goToStep('#product');
      }
    }
  }, [_c('a', [_vm._v("商品設定")]), _c('i', {
    class: "fa ".concat(_vm.groupbuying && _vm.groupbuying.sku ? 'fa-check-circle' : 'fa fa-check-circle-o'),
    style: _vm.groupbuying && _vm.groupbuying.sku ? 'color:green;' : '',
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('li', {
    class: _vm.step == '#product-setting' ? 'active' : '',
    style: _vm.isCreate || _vm.isNotSettingProduct ? 'cursor: not-allowed;' : 'cursor: pointer;',
    on: {
      "click": function click($event) {
        return _vm.goToStep('#product-setting');
      }
    }
  }, [_c('a', [_vm._v("商品圖片")]), _c('i', {
    class: "fa ".concat(_vm.productImages.length ? 'fa-check-circle' : 'fa fa-check-circle-o'),
    style: _vm.productImages.length ? 'color:green;' : '',
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('li', {
    class: _vm.step == '#advanced-setting' ? 'active' : '',
    style: _vm.isCreate || _vm.isNotSettingProduct ? 'cursor: not-allowed;' : 'cursor: pointer;',
    on: {
      "click": function click($event) {
        return _vm.goToStep('#advanced-setting');
      }
    }
  }, [_c('a', [_vm._v("進階設定")])]), _c('li', {
    class: _vm.step == '#status' ? 'active' : '',
    style: _vm.isCreate || _vm.isNotSettingProduct ? 'cursor: not-allowed;' : 'cursor: pointer;',
    on: {
      "click": function click($event) {
        return _vm.goToStep('#status');
      }
    }
  }, [_c('a', [_vm._v("狀態設定")])])])])]), _c('div', {
    staticClass: "mail-view d-none d-md-block col-md-9 col-lg-10 bg-white"
  }, [_c('b-card', [_vm.step == '' ? _c('section', {
    staticClass: "mb-5"
  }, [_c('h4', {
    staticClass: "mb-2 font-weight-bold"
  }, [_vm._v(" 團購設定 ")]), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "團購名稱",
      "label-for": "title"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0 col-12 col-xl-6",
    attrs: {
      "id": "title",
      "disabled": !_vm.isEdit && !_vm.isCreate,
      "state": _vm.v$.form.title.$error ? false : null
    },
    model: {
      value: _vm.form.title,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "title", $$v);
      },
      expression: "form.title"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.title.$error
    }
  }, [_vm._v(" 團購名稱為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "團購說明",
      "label-for": "description"
    }
  }, [_c('b-form-textarea', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0 col-12 col-xl-6",
    attrs: {
      "id": "description",
      "rows": "5",
      "disabled": !_vm.isEdit && !_vm.isCreate
    },
    model: {
      value: _vm.form.description,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "description", $$v);
      },
      expression: "form.description"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "下單說明",
      "label-for": "order_message"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0 col-12 col-xl-6",
    attrs: {
      "id": "order_message",
      "disabled": !_vm.isEdit && !_vm.isCreate
    },
    model: {
      value: _vm.form.order_message,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "order_message", $$v);
      },
      expression: "form.order_message"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "下單完成說明",
      "label-for": "success_message"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0 col-12 col-xl-6",
    attrs: {
      "id": "success_message",
      "disabled": !_vm.isEdit && !_vm.isCreate
    },
    model: {
      value: _vm.form.success_message,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "success_message", $$v);
      },
      expression: "form.success_message"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "開始時間"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "w-50"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "Select Date",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabled": (!_vm.isEdit && !_vm.isStatusPrepared || !_vm.isDraftGroupbuying) && !_vm.isCreate,
      "disabledDates": _vm.disabledDates
    },
    model: {
      value: _vm.form.start_at.date,
      callback: function callback($$v) {
        _vm.$set(_vm.form.start_at, "date", $$v);
      },
      expression: "form.start_at.date"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.start_at.date.required.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('div', {
    staticClass: "ml-2 w-50"
  }, [_c('vue-timepicker', {
    attrs: {
      "format": "HH:mm",
      "input-class": ['form-control', {
        'is-invalid': _vm.v$.form.start_at.time.HH.$error || _vm.v$.form.start_at.time.mm.$error
      }],
      "disabled": (!_vm.isEdit && !_vm.isStatusPrepared || !_vm.isDraftGroupbuying) && !_vm.isCreate
    },
    model: {
      value: _vm.form.start_at.time,
      callback: function callback($$v) {
        _vm.$set(_vm.form.start_at, "time", $$v);
      },
      expression: "form.start_at.time"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.start_at.time.HH.$error || !_vm.v$.form.start_at.time.mm.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1)])]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "截止時間",
      "description": "*達截止時間系統將自動結團"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "w-50"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "Select Date",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabled": !_vm.isEdit && !_vm.isCreate,
      "input-class": {
        'is-invalid': _vm.v$.form.start_at.$invalid
      },
      "disabledDates": _vm.disabledDates
    },
    model: {
      value: _vm.form.end_at.date,
      callback: function callback($$v) {
        _vm.$set(_vm.form.end_at, "date", $$v);
      },
      expression: "form.end_at.date"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.end_at.date.$error
    }
  }, [_vm._v(" 此欄位為必填 ")]), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.start_at.date.beforeEndAt.$invalid
    }
  }, [_vm._v(" 截止時間必須大於開團時間 ")])], 1), _c('div', {
    staticClass: "ml-2 w-50"
  }, [_c('vue-timepicker', {
    attrs: {
      "disabled": !_vm.isEdit && !_vm.isCreate,
      "input-class": ['form-control', {
        'is-invalid': _vm.v$.form.start_at.time.HH.$error || _vm.v$.form.start_at.time.mm.$error || _vm.v$.form.start_at.date.beforeEndAt.$invalid
      }]
    },
    model: {
      value: _vm.form.end_at.time,
      callback: function callback($$v) {
        _vm.$set(_vm.form.end_at, "time", $$v);
      },
      expression: "form.end_at.time"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.end_at.time.HH.$error || !_vm.v$.form.end_at.time.mm.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1)])]), _vm.isEdit || _vm.isCreate ? _c('div', {
    staticClass: "mt-5"
  }, [_c('br'), _c('br'), _c('br'), _c('b-button', {
    staticClass: "mr-5",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.backToList();
      }
    }
  }, [_vm._v("取消")]), _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.submitGroupbuying();
      }
    }
  }, [_vm._v("儲存")])], 1) : _vm._e()], 1) : _vm._e(), _vm.step == '#product' ? _c('section', {
    staticClass: "mb-5"
  }, [_c('h4', {
    staticClass: "mb-2 font-weight-bold"
  }, [_vm._v(" 商品設定 ")]), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "團購名稱",
      "label-for": "title"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0 col-12 col-xl-6",
    attrs: {
      "id": "title",
      "disabled": _vm.step != 1
    },
    model: {
      value: _vm.form.title,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "title", $$v);
      },
      expression: "form.title"
    }
  })], 1), _c('div', {
    staticClass: "row ml-1"
  }, [_c('b-form-radio', {
    staticClass: "mt-2 col-lg-2 col-6",
    attrs: {
      "aria-describedby": _vm.selected_product,
      "name": "selected_product",
      "value": "1"
    },
    model: {
      value: _vm.selected_product,
      callback: function callback($$v) {
        _vm.selected_product = $$v;
      },
      expression: "selected_product"
    }
  }, [_c('div', {
    staticClass: "s-radio-text"
  }, [_vm._v("選擇商品")])]), _c('div', {
    staticClass: "col-lg-9 col-6"
  }, [_c('b-form-select', {
    staticClass: "form-control form-control-sm mt-2 col-12 col-xl-6",
    attrs: {
      "id": "prodcut",
      "disabled": !_vm.isEdit && !_vm.isCreate || !_vm.isDraftGroupbuying || _vm.isCreateProduct
    },
    model: {
      value: _vm.product_sku_id,
      callback: function callback($$v) {
        _vm.product_sku_id = $$v;
      },
      expression: "product_sku_id"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": null,
      "disabled": ""
    }
  }, [_vm._v(" 請選擇商品編號 ")]), _vm._l(_vm.skuList, function (sku) {
    return _c('b-form-select-option', {
      key: sku.id,
      attrs: {
        "value": sku.id
      }
    }, [_vm._v(" " + _vm._s(_vm.getSkuOptionName(sku)) + " ")]);
  })], 2), _c('b-form-checkbox', {
    staticClass: "mb-2 mt-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "sync_to_cresclab",
      "name": "sync_to_cresclab",
      "disabled": !_vm.isEdit || _vm.isCreateProduct || !this.product_sku_id || !_vm.$permissions.has(_vm.$permissions.consts.CORE_GROUPBUYING_PRODUCT_MODIFY)
    },
    model: {
      value: _vm.edit_product,
      callback: function callback($$v) {
        _vm.edit_product = $$v;
      },
      expression: "edit_product"
    }
  }, [_vm._v("修改商品內容")])], 1)], 1), _c('b-form-radio', {
    staticClass: "mb-2",
    attrs: {
      "aria-describedby": _vm.selected_product,
      "name": "selected_product",
      "value": "2",
      "disabled": !_vm.isDraftGroupbuying || !_vm.$permissions.has(_vm.$permissions.consts.CORE_GROUPBUYING_PRODUCT_CREATE)
    },
    model: {
      value: _vm.selected_product,
      callback: function callback($$v) {
        _vm.selected_product = $$v;
      },
      expression: "selected_product"
    }
  }, [_c('div', {
    staticClass: "s-radio-text"
  }, [_vm._v("新增商品")])]), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "商品名稱",
      "label-for": "product_title"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0 col-12 col-xl-6",
    attrs: {
      "id": "title",
      "disabled": !_vm.isEdit || !_vm.isDraftGroupbuying || !(_vm.isEditProduct || _vm.isCreateProduct)
    },
    model: {
      value: _vm.form.product.title,
      callback: function callback($$v) {
        _vm.$set(_vm.form.product, "title", $$v);
      },
      expression: "form.product.title"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "商品規格",
      "label-for": "sku_name"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0 col-12 col-xl-6",
    attrs: {
      "id": "title",
      "disabled": !_vm.isEdit || !_vm.isDraftGroupbuying || !(_vm.isEditProduct || _vm.isCreateProduct)
    },
    model: {
      value: _vm.form.sku.sku_name,
      callback: function callback($$v) {
        _vm.$set(_vm.form.sku, "sku_name", $$v);
      },
      expression: "form.sku.sku_name"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "商品說明",
      "label-for": "product_description"
    }
  }, [_c('b-form-textarea', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0 col-12 col-xl-6",
    attrs: {
      "id": "title",
      "disabled": !_vm.isEdit || !_vm.isDraftGroupbuying || !(_vm.isEditProduct || _vm.isCreateProduct)
    },
    model: {
      value: _vm.form.product.description,
      callback: function callback($$v) {
        _vm.$set(_vm.form.product, "description", $$v);
      },
      expression: "form.product.description"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "商品店內碼(選填）",
      "label-for": "product_sku_sku_outer_code"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0 col-12 col-xl-6",
    attrs: {
      "id": "title",
      "disabled": !_vm.isEdit || !_vm.isDraftGroupbuying || !(_vm.isEditProduct || _vm.isCreateProduct)
    },
    model: {
      value: _vm.form.sku.sku_outer_code,
      callback: function callback($$v) {
        _vm.$set(_vm.form.sku, "sku_outer_code", $$v);
      },
      expression: "form.sku.sku_outer_code"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "商品條碼(選填）",
      "label-for": "product_sku_sku_serial_number"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0 col-12 col-xl-6",
    attrs: {
      "id": "title",
      "disabled": !_vm.isEdit || !_vm.isDraftGroupbuying || !(_vm.isEditProduct || _vm.isCreateProduct)
    },
    model: {
      value: _vm.form.sku.sku_serial_number,
      callback: function callback($$v) {
        _vm.$set(_vm.form.sku, "sku_serial_number", $$v);
      },
      expression: "form.sku.sku_serial_number"
    }
  })], 1), _vm.isEdit && _vm.isDraftGroupbuying ? _c('div', [_c('b-button', {
    staticClass: "mr-5",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.backToList();
      }
    }
  }, [_vm._v("取消")]), _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.submitProduct();
      }
    }
  }, [_vm._v("儲存")])], 1) : _vm._e()], 1) : _vm._e(), _vm.step == '#product-setting' ? _c('section', {
    staticClass: "mb-5"
  }, [_c('h4', {
    staticClass: "mb-2 font-weight-bold"
  }, [_vm._v(" 商品圖片 ")]), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "團購名稱",
      "label-for": "title"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "title",
      "disabled": _vm.step != 1
    },
    model: {
      value: _vm.form.title,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "title", $$v);
      },
      expression: "form.title"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "商品名稱",
      "label-for": "product.title"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "product.title",
      "disabled": _vm.step != 2
    },
    model: {
      value: _vm.form.product.title,
      callback: function callback($$v) {
        _vm.$set(_vm.form.product, "title", $$v);
      },
      expression: "form.product.title"
    }
  })], 1), _c('div', {
    staticClass: "mb-2 text-danger"
  }, [_vm._v("商品照片上傳最少需1張，上限為10張")]), _c('div', {
    staticClass: "mb-2 text-danger"
  }, [_vm._v("建議尺寸 1400px X 1400px")]), _c('input', {
    ref: "input",
    staticClass: "s-file-input",
    attrs: {
      "type": "file",
      "name": "image",
      "accept": "image/*",
      "multiple": true
    },
    on: {
      "change": _vm.loadImage
    }
  }), _vm.productImages.length < 10 ? _c('div', {
    staticClass: "mb-5"
  }, [_c('div', {
    staticClass: "s-cropper-inner"
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('button', {
    staticClass: "btn s-trigger-btn",
    attrs: {
      "disabled": !_vm.canClick
    },
    on: {
      "click": _vm.openFileSelector
    }
  }, [_vm.canClick ? [_c('div', {
    staticClass: "add-image-icon"
  }, [_vm._v("＋")]), _c('div', [_vm._v("新增")])] : _vm._e(), !_vm.canClick ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.uploadingText())
    }
  }) : _vm._e()], 2)])])]) : _vm._e(), _c('VueDraggable', {
    staticClass: "list-unstyled s-image-list mb-5",
    attrs: {
      "handle": ".s-draggable",
      "tag": "ul",
      "move": _vm.checkMove
    },
    on: {
      "end": _vm.dragEnd
    },
    model: {
      value: _vm.productImages,
      callback: function callback($$v) {
        _vm.productImages = $$v;
      },
      expression: "productImages"
    }
  }, _vm._l(_vm.productImages, function (image, i) {
    return _c('li', {
      key: i,
      staticClass: "s-image-list-item"
    }, [_c('div', {
      staticClass: "s-draggable"
    }, [_c('img', {
      staticClass: "s-cropped-image",
      attrs: {
        "src": image.pic_url
      }
    }), _c('button', {
      staticClass: "btn btn-secondary s-delete-btn",
      attrs: {
        "type": "button"
      }
    }, [_c('svg', {
      staticStyle: {
        "width": "22px"
      },
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "fill": "none",
        "viewBox": "0 0 24 24",
        "stroke-width": "1",
        "stroke": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "d": "M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15"
      }
    })])])]), _c('div', {
      staticClass: "s-list-item-btn-menu"
    }, [_c('b-button', {
      attrs: {
        "disabled": !_vm.canClick,
        "variant": "outline-danger"
      },
      on: {
        "click": function click($event) {
          return _vm.deleteImage(i);
        }
      }
    }, [_vm._v("刪除")])], 1)]);
  }), 0)], 1) : _vm._e(), _vm.step == '#advanced-setting' ? _c('section', {
    staticClass: "mb-5"
  }, [_c('h4', {
    staticClass: "mb-2 font-weight-bold"
  }, [_vm._v(" 進階設定 ")]), _c('h5', {
    staticClass: "mb-2 font-weight-bold"
  }, [_vm._v(" 前台顯示 ")]), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "顯示累積數量"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "id": "show_total_amount",
      "name": "show_total_amount",
      "disabled": !_vm.isEdit
    },
    model: {
      value: _vm.form.show_total_amount,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "show_total_amount", $$v);
      },
      expression: "form.show_total_amount"
    }
  }, [_c('b-form-radio', {
    attrs: {
      "value": true
    }
  }, [_vm._v("顯示")]), _c('b-form-radio', {
    attrs: {
      "value": false
    }
  }, [_vm._v("不顯示")])], 1)], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "手動調整數量"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "id": "adjust_quantity",
      "type": "number",
      "formatter": function formatter(value) {
        return value < 0 ? 0 : Math.round(value);
      },
      "disabled": !_vm.isEdit
    },
    model: {
      value: _vm.form.adjust_quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "adjust_quantity", $$v);
      },
      expression: "form.adjust_quantity"
    }
  })], 1), _c('h5', {
    staticClass: "mb-2 font-weight-bold"
  }, [_vm._v(" 下單設定 ")]), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "團購數量上限",
      "label-for": "max_quantity"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "id": "max_quantity",
      "type": "number",
      "formatter": function formatter(value) {
        return value < 0 ? 0 : Math.round(value);
      },
      "disabled": !_vm.isEdit && !_vm.isStatusPrepared
    },
    model: {
      value: _vm.form.max_quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "max_quantity", $$v);
      },
      expression: "form.max_quantity"
    }
  }), _vm._v(" （ 0 為不設限 ） ")], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "可否重複下單"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "id": "can_order_again",
      "name": "can_order_again",
      "disabled": !_vm.isEdit || !_vm.isDraftGroupbuying
    },
    model: {
      value: _vm.form.can_order_again,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "can_order_again", $$v);
      },
      expression: "form.can_order_again"
    }
  }, [_c('b-form-radio', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("可重複下單")]), _c('b-form-radio', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("不可重複下單")])], 1)], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "每人購買上限數",
      "label-for": "max_purchase_limit"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "id": "max_purchase_limit",
      "type": "number",
      "formatter": function formatter(value) {
        return value < 0 ? 0 : Math.round(value);
      },
      "disabled": !_vm.isEdit && !_vm.isStatusPrepared || _vm.form.can_order_again == '0'
    },
    model: {
      value: _vm.form.max_purchase_limit,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "max_purchase_limit", $$v);
      },
      expression: "form.max_purchase_limit"
    }
  }), _vm._v(" （ 0 為不設限 ） ")], 1), false ? _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "數量選擇"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "id": "need_choose_number",
      "name": "need_choose_number",
      "disabled": !_vm.isEdit
    },
    model: {
      value: _vm.form.need_choose_number,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "need_choose_number", $$v);
      },
      expression: "form.need_choose_number"
    }
  }, [_c('b-form-radio', {
    attrs: {
      "value": true
    }
  }, [_vm._v("需選擇數量")]), _c('b-form-radio', {
    attrs: {
      "value": false
    }
  }, [_vm._v("不需選擇數量")])], 1)], 1) : _vm._e(), false ? _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "每人最高購買數",
      "label-for": "once_max_quantity"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "id": "once_max_quantity",
      "type": "number",
      "formatter": function formatter(value) {
        return value < 0 ? 0 : Math.round(value);
      },
      "disabled": !_vm.isEdit && !_vm.isStatusPrepared || !_vm.form.need_choose_number,
      "state": _vm.v$.form.once_max_quantity.$error ? false : null
    },
    model: {
      value: _vm.form.once_max_quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "once_max_quantity", $$v);
      },
      expression: "form.once_max_quantity"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.once_max_quantity.less.$invalid
    }
  }, [_vm._v(" 需小於商品總數上限 ")]), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.once_max_quantity.thanzero.$invalid
    }
  }, [_vm._v(" 最低數量為1 ")])], 1) : _vm._e(), false ? _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "每人最低購買數",
      "label-for": "once_quantity"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "id": "once_quantity",
      "type": "number",
      "formatter": function formatter(value) {
        return value < 1 ? 1 : Math.round(value);
      },
      "disabled": !_vm.isEdit && !_vm.isStatusPrepared || !_vm.form.need_choose_number,
      "state": _vm.v$.form.once_quantity.$error ? false : null
    },
    model: {
      value: _vm.form.once_quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "once_quantity", $$v);
      },
      expression: "form.once_quantity"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.once_quantity.less.$invalid
    }
  }, [_vm._v(" 需小於每人最高購買數 ")])], 1) : _vm._e(), false ? _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "下單數量遞增數",
      "label-for": "once_increase_quantity"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "id": "once_increase_quantity",
      "type": "number",
      "formatter": function formatter(value) {
        return value < 1 ? 1 : Math.round(value);
      },
      "disabled": !_vm.isEdit && !_vm.isStatusPrepared || !_vm.form.need_choose_number,
      "state": _vm.v$.form.once_increase_quantity.$error ? false : null
    },
    model: {
      value: _vm.form.once_increase_quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "once_increase_quantity", $$v);
      },
      expression: "form.once_increase_quantity"
    }
  })], 1) : _vm._e(), false ? _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "分店選擇"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "id": "need_choose_branch",
      "name": "need_choose_branch",
      "disabled": !_vm.isEdit
    },
    model: {
      value: _vm.form.need_choose_branch,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "need_choose_branch", $$v);
      },
      expression: "form.need_choose_branch"
    }
  }, [_c('b-form-radio', {
    attrs: {
      "value": true
    }
  }, [_vm._v("需分店選擇")]), _c('b-form-radio', {
    attrs: {
      "value": false
    }
  }, [_vm._v("不需分店選擇")])], 1)], 1) : _vm._e(), _c('h5', {
    staticClass: "mb-2 font-weight-bold"
  }, [_vm._v(" 下單後動作 ")]), false ? _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "貼標"
    }
  }, [_c('b-form-tags', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0 col-12 col-xl-6",
    attrs: {
      "input-id": "tags",
      "placeholder": "輸入標籤",
      "size": "lg",
      "tag-variant": "dark",
      "disabled": !_vm.isEdit || !_vm.isDraftGroupbuying,
      "remove-on-delete": "",
      "no-add-on-enter": "",
      "separator": " ,;"
    },
    model: {
      value: _vm.form.tags,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "tags", $$v);
      },
      expression: "form.tags"
    }
  }), false ? _c('b-form-checkbox', {
    staticClass: "mb-2 mt-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "sync_to_cresclab",
      "name": "sync_to_cresclab",
      "disabled": !_vm.isEdit
    },
    model: {
      value: _vm.form.sync_to_cresclab,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "sync_to_cresclab", $$v);
      },
      expression: "form.sync_to_cresclab"
    }
  }, [_vm._v("同步至漸強")]) : _vm._e()], 1) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "發放優惠券"
    }
  }, [_c('b-form-select', {
    staticClass: "mb-2 col-6",
    attrs: {
      "options": _vm.redeem_options,
      "disabled": !_vm.isEdit || !_vm.isDraftGroupbuying
    },
    model: {
      value: _vm.form.redeem_code,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "redeem_code", $$v);
      },
      expression: "form.redeem_code"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": null
    }
  }, [_vm._v("--")])], 1), _c('b-form-radio', {
    attrs: {
      "value": "1",
      "disabled": !_vm.isEdit && !_vm.isCreate || !_vm.form.redeem_code || !_vm.isDraftGroupbuying
    },
    model: {
      value: _vm.form.send_coupon,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "send_coupon", $$v);
      },
      expression: "form.send_coupon"
    }
  }, [_vm._v("下單後自動發送")]), _c('b-form-radio', {
    attrs: {
      "value": "2",
      "disabled": !_vm.isEdit && !_vm.isCreate || !_vm.form.redeem_code || !_vm.isDraftGroupbuying
    },
    model: {
      value: _vm.form.send_coupon,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "send_coupon", $$v);
      },
      expression: "form.send_coupon"
    }
  }, [_vm._v("結團後自動發送")])], 1), _vm.isEdit ? _c('div', [_c('b-button', {
    staticClass: "mr-5",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.backToList();
      }
    }
  }, [_vm._v("取消")]), _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.submitGroupbuying();
      }
    }
  }, [_vm._v("儲存")])], 1) : _vm._e()], 1) : _vm._e(), _vm.step == '#status' ? _c('section', {
    staticClass: "mb-5"
  }, [_c('h4', {
    staticClass: "mb-2 font-weight-bold"
  }, [_vm._v(" 狀態設定 ")]), _vm.groupbuying ? _c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" 團購編號：" + _vm._s(_vm.groupbuying.groupbuying_number) + " ")]), _c('div', [_vm._v("商品名稱：" + _vm._s(_vm.groupbuying.title))]), _c('div', [_vm._v("商品編號：" + _vm._s(_vm.form.product.sale_page_code))]), _c('div', [_vm._v("狀態：" + _vm._s(_vm.getStatusName(_vm.groupbuying.status)))]), _c('div', [_vm._v("建立時間： " + _vm._s(_vm.formatDateTime(_vm.groupbuying.created_at)))]), _c('div', [_vm._v("開始時間： " + _vm._s(_vm.formatDateTime(_vm.groupbuying.start_at)))]), _c('div', [_vm._v("截止時間： " + _vm._s(_vm.formatDateTime(_vm.groupbuying.end_at)))])]) : _vm._e(), _c('b-button', {
    staticClass: "mt-5",
    attrs: {
      "variant": "primary",
      "disabled": !_vm.isDraftGroupbuying
    },
    on: {
      "click": function click($event) {
        return _vm.startGroupbuying();
      }
    }
  }, [_vm._v("確定發起團購")])], 1) : _vm._e()])], 1)])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }